<template>
  <v-card v-if="reactive.aspect" raised class="mb-4" elevation="5">
    <v-layout pa-4>
      <v-flex sm1 class="d-flex justify-center align-center">
        <v-icon size="64">mdi-bookmark-multiple-outline</v-icon>
      </v-flex>
      <v-flex sm11>
        <v-layout wrap>
          <v-flex sm10>{{ reactive.title }}</v-flex>
          <v-flex sm2>
            <v-icon @click="dialog = true" class="mr-2">mdi-pencil-outline</v-icon>
            <v-icon @click="dialogDelete = true" class="mr-2">mdi-close</v-icon>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex>
            <p class="grey--text text--darken-1">{{ reactive.aspect.title }}</p>
            <p class="grey--text text--darken-1">
              <v-icon class="mr-2">mdi-timer</v-icon>
              {{ reactive.timer }} s
            </p>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- Ventana para editar reactive -->
    <v-dialog v-model="dialog" width="50%">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Editar Reactivo</v-card-title>

        <v-form ref="form" @submit.prevent="send">
          <v-container>
            <v-layout wrap>
              <v-flex sm12>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field v-model="title" label="Nombre del reactivo" :rules="requiredRule"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-model="timer" label="Tiempo" :rules="requiredRule"></v-text-field>
                  </v-flex>

                  <v-select
                    :items="aspectsProp"
                    item-text="title"
                    v-model="aspect"
                    return-object
                    label="Aspecto"
                  ></v-select>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialog = false">cancelar</v-btn>
            <v-btn color="primary" text type="submit">Actualizar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Ventana para eliminar -->
    <v-dialog v-model="dialogDelete" width="50%">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Eliminar Reactivo</v-card-title>

        <v-card-text class="title">¿Estás seguro de eliminar a este reactivo?</v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialogDelete = false">cancelar</v-btn>
          <v-btn color="primary" text @click="deleteReactive">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" right top :timeout="3000">
      {{ message }}
      <v-btn color="blue" text @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import axios from "axios";
export default {
  name: "ReactiveCard",
  props: {
    reactive: Object,
    aspectsProp: Array
  },
  data() {
    return {
      requiredRule: [v => !!v || "Este campo es obligatorio"],
      dialog: false,
      dialogDelete: false,
      snackbar: false,
      aspect: this.reactive.aspect,
      aspects: this.aspectsProp,
      message: "",
      title: this.reactive.title,
      timer: this.reactive.timer,

      host: process.env.VUE_APP_HOST
    };
  },
  methods: {
    send() {
      if (this.$refs.form.validate()) {
        let data = {
          idReactive: this.reactive.idReactive,
          title: this.title,
          timer: this.timer,
          idAspect: this.aspect.idAspect,
          idUserVerify: sessionStorage.getItem("authorization")
        };

        axios
          .post(this.host + "/reactives/update.php", this.createFormData(data))
          .then(response => {
            this.dialog = false;
            this.snackbar = true;
            this.message = response.data.message;
            this.$emit("updateReactive");
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    deleteReactive() {
      let data = {
        idReactive: this.reactive.idReactive,
        idUserVerify: sessionStorage.getItem("authorization")
      };
      axios
        .post(this.host + "/reactives/delete.php", this.createFormData(data))
        .then(response => {
          this.dialogDelete = false;
          this.snackbar = true;
          this.message = response.data.message;
          this.$emit("updateReactive");
        })
        .catch(error => {
          console.log(error);
        });
    },
    createFormData(postData) {
      let formDa = new FormData();
      for (let key in postData) {
        formDa.append(key, postData[key]);
      }
      return formDa;
    }
  }
};
</script>
<style scoped>
.switch {
  width: 50px;
  display: inline-block;
}
</style>